import { svg } from "../svg";

export const ExpiredIcon = svg`
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="5 4 87 87">
    <circle cx="48" cy="48" r="42" class="tw-fill-illustration-bg-primary tw-stroke-illustration-outline" stroke-width="2"/>
    <rect width="18" height="14" x="12" y="70" class="tw-fill-illustration-bg-secondary tw-stroke-illustration-outline" stroke-width="2" rx="2"/>
    <rect width="2" height="6" x="20" y="74" class="tw-fill-illustration-outline" rx="1"/>
    <path class="tw-stroke-illustration-outline" stroke-width="2" d="M25 69v-1a4 4 0 0 0-8 0v1"/>
    <circle cx="80" cy="16" r="11" class="tw-fill-illustration-tertiary tw-stroke-illustration-outline" stroke-width="2"/>
    <path class="tw-stroke-illustration-outline" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m76.673 19.495 3.5-3.5m3.5-3.5-3.5 3.5m0 0-3.5-3.5 7 7"/>
    <circle cx="48" cy="48" r="15.5" class="tw-fill-illustration-bg-tertiary tw-stroke-illustration-outline" stroke-width="2"/>
    <path class="tw-stroke-illustration-outline" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M52.95 52.243 48 48.707v-9.9"/>
  </svg>
`;
